"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTAINER_SIZES = void 0;
exports.CONTAINER_SIZES = {
    small: {
        width: 32,
        height: 32,
    },
    medium: {
        width: 40,
        height: 40,
    },
    large: {
        width: 64,
        height: 64,
    },
    extraLarge: {
        width: 96,
        height: 96,
    },
};
